import { classNames } from './upsert-class.constant';

export const getOriginalFunctions = function (range: any) {
    let data = [
        {
            label: 'If',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: If([text1] = "Test", [text2], [text3]).\n\nThis If-Then-Else test for ternary check, ' +
                'If condition is evaluates to true then it returns “value1” otherwise “value2”.',
            insertText: 'If(${1:condition}, [${2:value1}], [${3:value2}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'TimeSpan',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: TimeSpan([d1], [d2], "days").\n\nCalculates the time period (double) between ' +
                'two dates in “days”, “months”, or “years”. d1 ' +
                'and d2 have the “Date” Field Type. The output ' +
                'in the example is in “months”. The Field Type ' +
                'must be set as Formula–Numeric.',
            insertText: 'TimeSpan([${1:d1}], [${2:d2}], "${3:days}")',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'AddTime',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: AddTime([d1], 2, "months").\n\nReturns a date after adding an offset amount to ' +
                'the given date where the offset is an integer in ' +
                '“days”, “months”, or “years”. The offset in the ' +
                'example is in “days”. The Field Type must be set ' +
                'as Formula–Date.',
            insertText: 'AddTime([${1:d1}], ${2:2}, "${3:months}")',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToDate',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: TimeSpan(ToDate([t1]), TODAY, "days").\n\nConverts the Timestamp or Datetime value to a Date value.',
            insertText: 'ToDate([${1:t1}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ParseDate',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: ParseDate([text]).\n\nConverts the string representation of a date and time to its DateTime equivalent.',
            insertText: 'ParseDate([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'IsNullOrWhiteSpace',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: IsNullOrWhiteSpace([text]).\n\nReturns true if the string is either null, ' +
                'empty, or consists exclusively of whitespace characters.',
            insertText: 'IsNullOrWhiteSpace([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToString',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [num].ToString().\n\nThis method is used to convert the value in string.',
            insertText: 'ToString()',
            range: range,
        },
        {
            label: 'ToString',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [date].ToString([${1:text}]).\n\nThis method is used to convert the value in string with specified format.',
            insertText: 'ToString([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToUser',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                "Example: ToUser([email]).\n\nThis method is used to get the user's username through email.",
            insertText: 'ToUser([${1:email}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Concat',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Concat([text1], [text2]).\n\nAppends one text string to another.',
            insertText: 'Concat([${1:text1}],[${2:text2}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Equals',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].Equals([text2]).\n\nReturns “true” if the string instance has the same value as a second string.',
            insertText: 'Equals([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Compare',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Compare([text1], [text2]).\n\nCompares the strings and returns their relative position in the sort order.',
            insertText: 'Compare([${1:text1}],[${2:text2}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Compare',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Compare([text1], [text2], true).\n\nCompares the strings and returns their relative position in the sort order while ignoring case.',
            insertText: 'Compare([${1:text1}],[${2:text2}], true)',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Compare',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Compare([text1], 3, [text2], 7, 4, true).\n\nCompares the substrings and returns their ' +
                'relative position in the sort order. The ' +
                'starting point of the comparison is given ' +
                'by the first two integers, while the third ' +
                'integer indicates the number of characters ' +
                'to compare. The last option of “true” ' +
                'ignores case.',
            insertText:
                'Compare([${1:text1}], ${2:3},[${3:text2}], ${4:7}, ${5:4}, true)',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'CompareTo',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].CompareTo([text2]).\n\nCompares the current string instance with ' +
                'the specified string, and returns their ' +
                'relative position in the sort order.',
            insertText: 'CompareTo([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Contains',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].Contains([text2]).\n\nReturns “true” if the specified substring occurs within the string instance.',
            insertText: 'Contains([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'EndsWith',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].EndsWith([text2]).\n\nReturns “true” if the end of the string instance matches the specified string.',
            insertText: 'EndsWith([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'StartsWith',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].StartsWith([text2]).\n\nReturns “true” if the start of the string instance matches the specified string.',
            insertText: 'StartsWith([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Remove',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].Remove(3, 5).\n\nReturns a string in which a specified ' +
                'number of characters in the current ' +
                'instance beginning at a specified position ' +
                'have been deleted. If the second number ' +
                "isn't specified, characters will be deleted " +
                'up to the end of the string.',
            insertText: 'Remove(${1:3}, ${2:5})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'SubString',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].SubString(3, 5).\n\nReturns a substring from the string ' +
                'instance. The substring starts at a ' +
                'specified character position and has a ' +
                'specified length. If length is omitted, the ' +
                'substring continues to the end of the string.',
            insertText: 'SubString(${1:3}, ${2:5})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Insert',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].Insert(5, [text2]).\n\nReturns a string in which the specified ' +
                'string is inserted at a specified position in ' +
                'the string instance.',
            insertText: 'Insert(${1:5}, [${2:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToUpper',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].ToUppper().\n\nReturns a copy of the string converted to uppercase.',
            insertText: 'ToUpper()',
            range: range,
        },
        {
            label: 'ToLower',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].ToLower().\n\nReturns a copy of the string converted to lowercase.',
            insertText: 'ToLower()',
            range: range,
        },
        {
            label: 'Format',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Format("{0:v1}, {1:v2}", [v1], [v2]).\n\nThe Format method is a special kind of text ' +
                'formula that can be used to replace all { } items ' +
                'within a string or paragraph with corresponding data ' +
                'listed at the end, which can be numerical, or text, or date data.',
            insertText: 'Format("{${1:0:v1}}", [${2:v1}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToCharArray',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].ToCharArray().\n\nReturns an array of characters from the ' +
                'specified instance. ' +
                '(Note: this method only works when ' +
                'nested within other methods, such as ' +
                '“Trim” or “IndexOfAny”.)',
            insertText: 'ToCharArray()',
            range: range,
        },
        {
            label: 'ToCharArray',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].ToCharArray(3, 5).\n\nReturns an array of characters from the ' +
                'specified instance. Optional parameters ' +
                'indicate starting position and length. ' +
                '(Note: this method only works when ' +
                'nested within other methods, such as ' +
                '“Trim” or “IndexOfAny”.)',
            insertText: 'ToCharArray(${1:3}, ${2:5})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Trim',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].Trim().\n\nRemoves all leading and trailing whitespace characters from the string instance.',
            insertText: 'Trim()',
            range: range,
        },
        {
            label: 'Trim',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].Trim([text2].ToCharArray()).\n\nRemoves all leading and trailing ' +
                'occurrences of a set of characters ' +
                'specified in an array from the string instance.',
            insertText: 'Trim([${1:text}].ToCharArray())',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'TrimStart',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].TrimStart([text2].ToCharArray()).\n\nRemoves all leading occurrences of a set ' +
                'of characters specified in an array from ' +
                'the string instance.',
            insertText: 'TrimStart([${1:text}].ToCharArray())',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'TrimEnd',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].TrimEnd([text2].ToCharArray()).\n\nRemoves all trailing occurrences of a set ' +
                'of characters specified in an array from ' +
                'the string instance.',
            insertText: 'TrimEnd([${1:text}].ToCharArray())',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'IndexOf',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].IndexOf("-").\n\nReturns the position of the first ' +
                'occurrence of the specified character in ' +
                'the string instance.',
            insertText: 'IndexOf("${1:-}")',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'IndexOf',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].IndexOf("-", 5, 8).\n\nReturns the position of the specified ' +
                'character in the string instance. The ' +
                'search starts at the specified character ' +
                'position and continues up to the specified ' +
                'number of character positions. If this ' +
                "number isn't specified, the search will " +
                'continue to the end of the string.',
            insertText: 'IndexOf("${1:-}", ${2:5}, ${3:8})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'IndexOf',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].IndexOf([text2]).\n\nReturns the position of the first ' +
                'occurrence of the specified string in the ' +
                'string instance.',
            insertText: 'IndexOf([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'IndexOf',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].IndexOf([text2], 5, 8).\n\nReturns the position of the specified string ' +
                'in the string instance. The search starts at ' +
                'the specified character position and ' +
                'continues up to the specified number of ' +
                "character positions. If this number isn't " +
                'specified, the search will continue to the ' +
                'end of the string.',
            insertText: 'IndexOf([${1:text}], ${2:5}, ${3:8})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'LastIndexOf',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].LastIndexOf("-").\n\nReturns the position of the last ' +
                'occurrence of the specified character in ' +
                'the string instance.',
            insertText: 'LastIndexOf("${1:-}")',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'LastIndexOf',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text].LastIndexOf("-", 5, 8).\n\nReturns the position of the specified ' +
                'character in the string instance. The ' +
                'search starts at the specified character ' +
                'position and continues backwards up to the specified ' +
                'number of character positions. If this ' +
                "number isn't specified, the search will " +
                'continue to the beginning of the string.',
            insertText: 'LastIndexOf("${1:-}", ${2:5}, ${3:8})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'LastIndexOf',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].LastIndexOf([text2]).\n\nReturns the position of the last ' +
                'occurrence of the specified string in the ' +
                'string instance.',
            insertText: 'LastIndexOf([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'LastIndexOf',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].LastIndexOf([text2], 5, 8).\n\nReturns the position of the specified string ' +
                'in the string instance. The search starts at ' +
                'the specified character position and ' +
                'continues backwards up to the specified number of ' +
                "character positions. If this number isn't " +
                'specified, the search will continue to the ' +
                'beginning of the string.',
            insertText: 'LastIndexOf([${1:text}], ${2:5}, ${3:8})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'IndexOfAny',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].IndexOfAny([text2].ToCharArray()).\n\nReturns the position of the first ' +
                'occurrence in the instance of any ' +
                'character in a specified array.',
            insertText: 'IndexOfAny([${1:text}].ToCharArray())',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'IndexOfAny',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: [text1].IndexOfAny([text2].ToCharArray(), 5, 8).\n\nReturns the position of the first ' +
                'occurrence in the instance of any ' +
                'character in a specified array. The search ' +
                'starts at a specified character position and ' +
                'examines a specified number of character ' +
                "positions. If this number isn't specified, " +
                'the search continues to the end of the string.',
            insertText: 'IndexOfAny([${1:text}].ToCharArray(), ${2:5}, ${3:8})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Abs',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Abs([num]).\n\nReturns the absolute value of the given number.',
            insertText: 'Abs([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Sign',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Sign([num]).\n\nEither 1 or -1 is returned, indicating the sign of the given number.',
            insertText: 'Sign([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Sqrt',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Sqrt([num]).\n\nCalculates the square root of the specified number (num1>=0).',
            insertText: 'Sqrt([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Pow',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Pow([num1], [num2]).\n\nReturns the absolute value of the given number.',
            insertText: 'Pow([${1:num1}], [${2:num2}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Exp',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Exp([num]).\n\nReturns the natural logarithm, ꬲ, raised to the specified power.',
            insertText: 'Exp([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Log',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Log([num]).\n\nReturns the natural logarithm of a specified number (base ꬲ).',
            insertText: 'Log([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Log',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Log([num1], [num2]).\n\nReturns the logarithm of a specified number (base specified in formula).',
            insertText: 'Log([${1:num1}], [${2:num2}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Log10',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Log10([num]).\n\nReturns the logarithm of a specified number (base 10).',
            insertText: 'Log10([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Max',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Max([num1], [num2]).\n\nReturns the larger of the two specified numbers.',
            insertText: 'Max([${1:num1}], [${2:num2}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Min',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Min([num1], [num2]).\n\nCalculates the integer part of a specified decimal number.',
            insertText: 'Min([${1:num1}], [${2:num2}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Truncate',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Truncate([num]).\n\nReturns the smaller of the two specified numbers.',
            insertText: 'Truncate([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Ceiling',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Ceiling([num]).\n\nReturns the smallest integer that is greater ' +
                'than or equal to the specified decimal number.',
            insertText: 'Ceiling([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Floor',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Floor([num]).\n\nReturns the largest integer less than or ' +
                'equal to the specified decimal number.',
            insertText: 'Floor([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Round',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Round([num]).\n\nRounds the given value to the nearest ' +
                'integer. If the value if it is midway between ' +
                'two integers, the nearest even integer is returned.',
            insertText: 'Round([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Round',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Round([num], 3).\n\nRounds the given value to a specified ' +
                'number of fractional digits.',
            insertText: 'Round([${1:num}], ${2:3})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Tan',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Tan([num]).\n\nReturns the tangent of the specified angle.',
            insertText: 'Tan([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Atan2',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Atan2([num1], [num2]).\n\nReturns the angle whose tangent is the ' +
                'quotient of the two numbers (num_2 != 0).',
            insertText: 'Atan2([${1:num1}], [${2:num2}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Cos',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Cos([num]).\n\nReturns the cosine of the specified angle.',
            insertText: 'Cos([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Acos',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Acos([num]).\n\nReturns the angle whose cosine is the ' +
                'specified number (Abs(num_1) <= 1).',
            insertText: 'Acos([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Sin',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Sin([num]).\n\nReturns the sine of the specified angle.',
            insertText: 'Sin([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Asin',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Asin([num]).\n\nReturns the angle whose sine is the ' +
                'specified number (Abs(num_1) <= 1).',
            insertText: 'Asin([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Cosh',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Cosh([num]).\n\nReturns the hyperbolic cosine of the specified angle.',
            insertText: 'Cosh([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Sinh',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Sinh([num]).\n\nReturns the hyperbolic sine of the specified angle.',
            insertText: 'Sinh([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'Tanh',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: Tanh([num]).\n\nReturns the hyperbolic tangent of the specified angle.',
            insertText: 'Tanh([${1:num}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToInt32',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: ToInt32([text]).\n\nConverts a specified value to a 32-bit signed integer.',
            insertText: 'ToInt32([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToSingle',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: ToSingle([text].SubString(3, 5)).\n\nReturns a single-precision floating-point value.',
            insertText: 'ToSingle([${1:text}].SubString(${2:3}, ${3:5}))',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToDouble',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: ToDouble([text]).\n\nConverts a specified value to a double-precision floating-point number.',
            insertText: 'ToDouble([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'ToDecimal',
            kind: (window as any).monaco.languages.CompletionItemKind.Function,
            documentation:
                'Example: ToDecimal([text]).\n\nConverts a specified value to a decimal number.',
            insertText: 'ToDecimal([${1:text}])',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            range: range,
        },
        {
            label: 'SPACE',
            kind: (window as any).monaco.languages.CompletionItemKind.Constant,
            documentation:
                'Example: [text1] + SPACE + [text2].\n\nThis is the constant for representing a “ ” value.',
            insertText: 'SPACE',
            range: range,
        },
        {
            label: 'TODAY',
            kind: (window as any).monaco.languages.CompletionItemKind.Constant,
            documentation:
                'Example: TimeSpan(TODAY, [d1], "days").\n\nThis is the constant for representing a DateTime.Now value.',
            insertText: 'TODAY',
            range: range,
        },
        {
            label: 'PI',
            kind: (window as any).monaco.languages.CompletionItemKind.Constant,
            documentation:
                'Example: PI * Pow([num], 2).\n\nThis is the constant Pi, π ,which is ratio of ' +
                'the circumference of a circle to its diameter.',
            insertText: 'PI',
            range: range,
        },
        {
            label: 'E',
            kind: (window as any).monaco.languages.CompletionItemKind.Constant,
            documentation:
                'Example: Pow(E, [num1]).\n\nThis is the constant, ꬲ, which is the natural logarithmic base.',
            insertText: 'E',
            range: range,
        },
        {
            label: 'AND',
            kind: (window as any).monaco.languages.CompletionItemKind.Operator,
            documentation:
                'Example: If([num1] > 10 AND [num2] > 20, [text1], [text2]).\n\nThis is the constant, ' +
                'which is used to add AND logic between two statements in a condition.',
            insertText: 'AND',
            range: range,
        },
        {
            label: 'OR',
            kind: (window as any).monaco.languages.CompletionItemKind.Operator,
            documentation:
                'Example: If([num1] > 10 OR [num2] > 20, [text1], [text2]).\n\nThis is the constant, ' +
                'which is used to add OR logic between two statements in a condition.',
            insertText: 'OR',
            range: range,
        },
        {
            label: 'Length',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation:
                'Example: [text1].Length.\n\nReturns the number of characters in the current string instance.',
            insertText: 'Length',
            range: range,
        },
        {
            label: 'DayOfWeek',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation:
                'Example: [text1].DayOfWeek.\n\nReturns the day of the week.',
            insertText: 'DayOfWeek',
            range: range,
        },
        {
            label: '<div>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines a section in a document.',
            insertText: '<div></div>',
            range: range,
        },
        {
            label: '<b>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines bold text.',
            insertText: '<b></b>',
            range: range,
        },
        {
            label: '<i>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation:
                'Defines a part of text in an alternate voice or mood.',
            insertText: '<i></i>',
            range: range,
        },
        {
            label: '<p>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines a paragraph.',
            insertText: '<p></p>',
            range: range,
        },
        {
            label: '<span>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines a section in a document.',
            insertText: '<span></span>',
            range: range,
        },
        {
            label: '<em>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines emphasized text.',
            insertText: '<em></em>',
            range: range,
        },
        {
            label: '<br>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines a single line break.',
            insertText: '<br>',
            range: range,
        },
        {
            label: '<h1>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines HTML headings.',
            insertText: '<h1></h1>',
            range: range,
        },
        {
            label: '<h2>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines HTML headings.',
            insertText: '<h2></h2>',
            range: range,
        },
        {
            label: '<h3>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines HTML headings.',
            insertText: '<h3></h3>',
            range: range,
        },
        {
            label: '<h4>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines HTML headings.',
            insertText: '<h4></h4>',
            range: range,
        },
        {
            label: '<h5>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines HTML headings.',
            insertText: '<h5></h5>',
            range: range,
        },
        {
            label: '<h6>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines HTML headings.',
            insertText: '<h6></h6>',
            range: range,
        },
        {
            label: '<button>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines HTML headings.',
            insertText: '<button></button>',
            range: range,
        },
        {
            label: '<a>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines a hyperlink.',
            insertText:
                "<a href='https://ignatius.io' target='_blank'>click here!</a>",
            range: range,
        },
        {
            label: '<img>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines an image.',
            insertText:
                "<img src='assets/images/OpenGov-Logo.svg' alt='default image'>",
            range: range,
        },
        {
            label: '<iframe>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines an image.',
            insertText:
                "<iframe style='height: 100%; width: 100%;' frameborder='0' src='ignatius.io'></iframe>",
            range: range,
        },
        {
            label: '<table>',
            kind: (window as any).monaco.languages.CompletionItemKind.Property,
            documentation: 'Defines HTML headings.',
            insertText: '<table><tr><td></td></tr></table>',
            range: range,
        },
    ];

    const copy = [...data];
    return copy;
};

export const allowedHtmlTags = [
    'div',
    'p',
    'i',
    'b',
    'br',
    'span',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'img',
    'iframe',
    'a',
    'button',
    'ul',
    'li',
    'table',
    'tr',
    'td',
    'th',
    'caption',
    'colgroup',
    'thead',
    'tfoot',
    'tbody',
];

export const methodsWithParam = new Map<string, number>([
    ['If', 3],
    ['AddTime', 3],
    ['TimeSpan', 3],
    ['ToDate', 1],
    ['ParseDate', 1],
    ['IsNullOrWhiteSpace', 1],
    ['ToUser', 1],
    ['Concat', 2],
    ['Concat_3', 3],
    ['Concat_4', 4],
    ['Concat_5', 5],
    ['Concat_6', 6],
    ['Concat_7', 7],
    ['Concat_8', 8],
    ['Concat_9', 9],
    ['Concat_10', 10],
    ['Equals', 1],
    ['CompareTo', 1],
    ['Compare', 2],
    ['Contains', 1],
    ['EndsWith', 1],
    ['StartsWith', 1],
    ['Remove', 1],
    ['SubString', 1],
    ['SubString_2', 2],
    ['Insert', 2],
    ['Format', 2],
    ['Format_3', 3],
    ['Format_4', 4],
    ['Format_5', 5],
    ['Format_6', 6],
    ['Format_7', 7],
    ['Format_8', 8],
    ['Format_9', 9],
    ['Format_10', 10],
    ['TrimStart', 1],
    ['TrimEnd', 1],
    ['IndexOf', 1],
    ['LastIndexOf', 1],
    ['IndexOfAny', 1],
    ['Abs', 1],
    ['Sign', 1],
    ['Sqrt', 1],
    ['Pow', 2],
    ['Exp', 1],
    ['Log', 1],
    ['Log10', 1],
    ['Max', 2],
    ['Min', 2],
    ['Truncate', 1],
    ['Ceiling', 1],
    ['Floor', 1],
    ['Round', 1],
    ['Tan', 1],
    ['Atan2', 2],
    ['Cos', 1],
    ['Acos', 1],
    ['Sin', 1],
    ['Asin', 1],
    ['Cosh', 1],
    ['Sinh', 1],
    ['Tanh', 1],
    ['ToInt32', 1],
    ['ToSingle', 1],
    ['ToDouble', 1],
    ['ToDecimal', 1],
    ['ToString', 0],
    ['ToString_1', 1],
    ['Compare_3', 3],
    ['Compare_6', 6],
    ['IndexOf_3', 3],
    ['LastIndexOf_3', 3],
    ['ToCharArray', 0],
    ['ToCharArray_2', 2],
    ['Log_2', 2],
    ['Trim', 0],
    ['Trim_1', 1],
    ['Round_2', 2],
    ['Remove_2', 2],
]);

export const createCssClassNameSuggestions = function (range: any) {
    const allClassNames = classNames;

    return allClassNames.map((className: any) => ({
        label: '.' + className,
        kind: (window as any).monaco.languages.CompletionItemKind.Class,
        documentation: 'Defines CSS Classes.',
        insertText: '.' + className,
        range: range,
    }));
};

export const getSQLFuctions = function () {
    let sqlCompletionItems = [
        {
            label: 'SELECT',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'SELECT ${1:*} FROM ${2:table} where ${3:id} = ${4:0};',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Select statement',
            documentation: 'Selects data from a database',
        },
        {
            label: 'FROM',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'FROM ',
            detail: 'From clause',
            documentation: 'Specifies the table to select or delete data from',
        },
        {
            label: 'WHERE',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'WHERE ',
            detail: 'Where clause',
            documentation: 'Filters records',
        },
        {
            label: 'INSERT INTO',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText:
                'INSERT INTO ${1:table} (${2:column1}, ${3:column2}) VALUES (${4:value1}, ${5:value2});',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Insert statement',
            documentation: 'Inserts new data into a database',
        },
        {
            label: 'UPDATE',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText:
                'UPDATE ${1:table} SET ${2:column} = ${3:value} WHERE ${4:condition};',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Update statement',
            documentation: 'Updates existing data within a database',
        },
        {
            label: 'DELETE',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'DELETE FROM ',
            detail: 'Delete statement',
            documentation: 'Deletes data from a database',
        },
        {
            label: 'JOIN',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'JOIN ',
            detail: 'Join clause',
            documentation: 'Combines rows from two or more tables',
        },
        {
            label: 'INNER JOIN',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'INNER JOIN ',
            detail: 'Inner join clause',
            documentation:
                'Returns records that have matching values in both tables',
        },
        {
            label: 'LEFT JOIN',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'LEFT JOIN ',
            detail: 'Left join clause',
            documentation:
                'Returns all records from the left table, and the matched records from the right table',
        },
        {
            label: 'GROUP BY',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'GROUP BY ',
            detail: 'Group by clause',
            documentation: 'Groups rows that have the same values',
        },
        {
            label: 'ORDER BY',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'ORDER BY ',
            detail: 'Order by clause',
            documentation:
                'Sorts the result set in ascending or descending order',
        },
        {
            label: 'VARCHAR',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'VARCHAR(${1:length})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Variable character field',
            documentation: 'A variable-length string',
        },
        {
            label: 'INT',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'INT',
            detail: 'Integer data type',
            documentation: 'A whole number data type',
        },
        {
            label: 'DATETIME',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'DATETIME',
            detail: 'Date and time data type',
            documentation: 'A date and time combination data type',
        },
        {
            label: 'DECIMAL',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'DECIMAL(${1:precision}, ${2:scale})',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Decimal number',
            documentation:
                'An exact numeric data type that holds numbers with fractional parts',
        },
        // Additional Snippets
        {
            label: 'CREATE TABLE',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText:
                'CREATE TABLE ${1:table_name} (\n\t${2:column_name} ${3:data_type}\n);',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Create table statement',
            documentation: 'Creates a new table in the database',
        },
        {
            label: 'ALTER TABLE',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText:
                'ALTER TABLE ${1:table_name} \nADD ${2:column_name} ${3:data_type};',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Alter table statement',
            documentation: 'Adds, deletes, or modifies columns in a table',
        },
        {
            label: 'DROP TABLE',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'DROP TABLE ${1:table_name};',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Drop table statement',
            documentation:
                'Deletes a table and its data permanently from the database',
        },
        {
            label: 'CREATE INDEX',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText:
                'CREATE INDEX ${1:index_name} ON ${2:table_name}(${3:column_name});',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Create index statement',
            documentation: 'Creates an index on a table column',
        },
        {
            label: 'DISTINCT',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'DISTINCT ',
            detail: 'Distinct keyword',
            documentation: 'Selects only distinct (different) values',
        },
        {
            label: 'UNION',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'UNION ',
            detail: 'Union keyword',
            documentation:
                'Combines the result-set of two or more SELECT statements',
        },
        {
            label: 'EXISTS',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'EXISTS ',
            detail: 'Exists operator',
            documentation:
                'Tests for the existence of any record in a subquery',
        },
        {
            label: 'HAVING',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText: 'HAVING ',
            detail: 'Having clause',
            documentation:
                'Used to filter records that have aggregate functions',
        },
        {
            label: 'CASE',
            kind: (window as any).monaco.languages.CompletionItemKind.Snippet,
            insertText:
                'CASE\n\tWHEN ${1:condition} THEN ${2:result}\n\tELSE ${3:default_result}\nEND',
            insertTextRules: (window as any).monaco.languages
                .CompletionItemInsertTextRule.InsertAsSnippet,
            detail: 'Case statement',
            documentation: 'Provides conditional logic in SQL queries',
        },
        // Add more suggestions as needed
    ];

    const copy = [...sqlCompletionItems];
    return copy;
};

export const fieldTypes = [
    'Text',
    'Text - Multi-line',
    'Text - Multiple Choice',
    'Text - Multiple Select',
    'Numeric',
    'Currency',
    'Phone Number',
    'Email',
    'Date/Time',
    'Date',
    'Checkbox',
    'File Attachment',
    'URL',
    'Formula - Text',
    'Formula - Numeric',
    'Formula - Currency',
    'Formula - Date',
    'Formula - URL',
    'User',
    'Encrypted (Standard)',
    'Encrypted (Extra Secure)',
    'Summary',
    'Relationship',
    'Primary Key',
    'UUID',
];

export const statusOptions = [
    { label: '(_blank)', value: '' },
    { label: 'Succeed', value: 'Succeed' },
    { label: 'Failed', value: 'Failed' },
];
